import React from "react"
import styled, { keyframes } from "styled-components"
import { colors } from "../../../../components/Color"

const bounceAnimation = keyframes`
  0% {
    transform: scale(1) translateY(0);
    border-radius: 100%;
  }
  
  50% {
    // border-radius: 0;
    transform: scale(1.2) translateY(-15px);
  }
  
  100% {
    border-radius: 100%;
    transform: scale(1) translateY(0);
  }
`

const LoadingIndicator = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: ${props => (props.filled ? colors.teal : "transparent")};
  border: 1px solid transparent;
  border-color: ${props => (!props.filled ? colors.teal : "transparent")};
  animation: ${bounceAnimation} 1s infinite;
  animation-delay: ${props => props.delay * 0.1}s;
  margin-right: 10px;
`

const Indicators = styled.div`
  display: flex;
  margin-bottom: 70px;
`

export default ({ percentage, numberOfIndicators = 5 }) => {
  const percentagToColoredIndex =
    percentage != null
      ? Math.floor((percentage / 100) * numberOfIndicators)
      : numberOfIndicators
  return (
    <Indicators>
      {Array(numberOfIndicators)
        .fill(1)
        .map((_, index) => (
          <LoadingIndicator
            key={`LoadingIndicator-${index}`}
            delay={index}
            filled={index < percentagToColoredIndex}
          />
        ))}
    </Indicators>
  )
}
